import Home from './views/Home';

export default [
    {
        exact: true,
        path: '/:eventId?',
        component: Home
    },
    {
        exact: true,
        path: '/:eventId?/:viewMode?',
        component: Home
    },
];



// WEBPACK FOOTER //
// ./src/routes.js